import { useCallback } from 'react'
import ApiService from 'services/ApiService'
import { getMessage } from 'utility/MapperResponse'
import { getTranslate } from 'utility/MapperTranslate'
import { showAlert } from 'utility/SweetAlert'

const InteractorTransactionReturLinesUpdate = () => {
  const transactionReturLinesUpdate = useCallback((body, callback) => {
    const payload = {
      ...body,
    }
    ApiService.jsonRequest('/transaction/retur-lines/update', payload, (response) => {
      if (response.code === 7200) {
        callback(response.data)
        showAlert({
          icon: 'success',
          message: getTranslate('message.successfully_updated'),
          timer: 2000,
        })
      } else {
        showAlert({
          icon: 'error',
          message: getMessage(response?.msg),
          timer: 2000,
        })
      }
    })
  }, [])
  return { transactionReturLinesUpdate }
}

export default InteractorTransactionReturLinesUpdate
